import TaskAssigneesTemplate from "./TaskAssigneesTemplate";

export default TaskAssigneesTemplate;
